import { SVGProps } from 'react';

export function Logo(props: SVGProps<SVGSVGElement>) {
  const { fill, stroke } = props;
  return (
    <svg id="Logo" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 102 38" width="102" height="38" xmlSpace="preserve">
      <g>
        <g>
          <polygon fill={fill ?? '#FD8625'} points="6.02,4.22 0,0 0,8.78 6.02,13 26.9,13 26.9,4.22" />
          <polygon fill={fill ?? '#FD8625'} points="20.29,25.39 20.29,16.61 6.02,16.61 0,12.4 0,21.17 6.02,25.3" />
          <polygon fill={fill ?? '#FD8625'} points="26.9,29 6.02,29 6.02,29 0,24.79 0,33.57 6.02,37.78 6.02,37.78 26.9,37.78" />
        </g>
        <g>
          <g>
            <path fill={stroke ?? '#FFFFFF'} d="M33.68,23.16V4.22h12.73v3.85h-8.32v3.58h7.86v3.66h-7.86v3.93h8.8v3.91H33.68z" />
            <path
              fill={stroke ?? '#FFFFFF'}
              d="M60.37,23.16c-1.5,0-2.87-0.21-4.12-0.64c-1.25-0.43-2.31-1.06-3.2-1.89c-0.88-0.83-1.57-1.85-2.06-3.05
              c-0.49-1.2-0.74-2.58-0.74-4.13c0-1.44,0.26-2.76,0.78-3.96c0.52-1.2,1.23-2.22,2.15-3.08c0.92-0.86,2.01-1.52,3.26-1.99
              c1.26-0.47,2.62-0.71,4.08-0.71c1.46,0,2.82,0.24,4.07,0.71c1.25,0.47,2.33,1.13,3.24,1.98c0.91,0.85,1.62,1.86,2.13,3.05
              c0.51,1.19,0.76,2.49,0.76,3.92c0,0.73-0.08,1.41-0.24,2.05c-0.16,0.63-0.37,1.21-0.64,1.73c-0.27,0.52-0.57,0.98-0.91,1.38
              c-0.34,0.4-0.68,0.74-1.02,1v0.08l3.99-0.08v3.64H60.37z M65.89,13.51c0-0.82-0.13-1.58-0.39-2.27c-0.26-0.7-0.62-1.29-1.1-1.79
              c-0.47-0.5-1.04-0.89-1.7-1.16C62.04,8,61.32,7.86,60.54,7.86c-0.77,0-1.48,0.14-2.13,0.41c-0.65,0.28-1.22,0.66-1.7,1.16
              c-0.48,0.5-0.86,1.1-1.12,1.79c-0.27,0.7-0.4,1.45-0.4,2.27c0,0.86,0.13,1.64,0.39,2.34c0.26,0.7,0.62,1.31,1.1,1.82
              c0.47,0.51,1.03,0.9,1.69,1.18c0.65,0.28,1.37,0.41,2.15,0.41c0.77,0,1.48-0.14,2.14-0.41c0.66-0.28,1.23-0.67,1.71-1.18
              c0.48-0.51,0.86-1.11,1.12-1.82C65.75,15.14,65.89,14.36,65.89,13.51z"
            />
            <path
              fill={stroke ?? '#FFFFFF'}
              d="M90.99,19.14c-0.38,0.94-0.93,1.74-1.65,2.41c-0.71,0.67-1.57,1.19-2.58,1.57
              c-1.01,0.37-2.13,0.56-3.36,0.56c-1.25,0-2.37-0.19-3.37-0.56c-1-0.37-1.85-0.9-2.54-1.57c-0.7-0.67-1.23-1.47-1.61-2.41
              c-0.37-0.94-0.56-1.97-0.56-3.12V4.22h4.55v11.42c0,0.52,0.07,1.01,0.2,1.47c0.13,0.46,0.34,0.88,0.62,1.24
              c0.28,0.37,0.64,0.66,1.1,0.87c0.46,0.21,1,0.32,1.65,0.32c0.64,0,1.19-0.11,1.65-0.32c0.45-0.21,0.82-0.5,1.11-0.87
              c0.29-0.37,0.49-0.78,0.62-1.24c0.12-0.46,0.19-0.95,0.19-1.47V4.22h4.57v11.8C91.57,17.16,91.37,18.2,90.99,19.14z"
            />
            <path fill={stroke ?? '#FFFFFF'} d="M96.6,23.16V4.22h4.6v18.94H96.6z" />
          </g>
          <g>
            <g>
              <path fill={stroke ?? '#FFFFFF'} d="M33.68,28.99h5.45v0.97h-4.41v2.9h4.1v0.97h-4.1v3.95h-1.04V28.99z" />
              <path fill={stroke ?? '#FFFFFF'} d="M43.05,28.99h1.04v8.79h-1.04V28.99z" />
              <path fill={stroke ?? '#FFFFFF'} d="M48.75,28.99h1.32l5.09,7.3h0.02v-7.3h1.04v8.79h-1.32l-5.09-7.3H49.8v7.3h-1.04V28.99z" />
              <path
                fill={stroke ?? '#FFFFFF'}
                d="M63.74,28.99h0.98l3.74,8.79h-1.22l-0.89-2.16h-4.39l-0.91,2.16h-1.18L63.74,28.99z M64.21,30.33h-0.02
                l-1.82,4.32h3.59L64.21,30.33z"
              />
              <path fill={stroke ?? '#FFFFFF'} d="M72.09,28.99h1.32l5.09,7.3h0.02v-7.3h1.04v8.79h-1.32l-5.09-7.3h-0.02v7.3h-1.04V28.99z" />
              <path
                fill={stroke ?? '#FFFFFF'}
                d="M90.38,30.8c-0.26-0.36-0.59-0.62-0.98-0.8c-0.39-0.18-0.79-0.27-1.22-0.27c-0.49,0-0.94,0.1-1.35,0.3
                c-0.41,0.2-0.76,0.47-1.06,0.8c-0.3,0.34-0.53,0.72-0.7,1.17c-0.17,0.44-0.25,0.9-0.25,1.38c0,0.51,0.08,0.99,0.25,1.43
                c0.17,0.44,0.4,0.83,0.69,1.15c0.29,0.33,0.65,0.59,1.06,0.78c0.41,0.19,0.86,0.29,1.36,0.29c0.54,0,1.02-0.11,1.44-0.32
                c0.42-0.21,0.79-0.52,1.1-0.91l0.78,0.66c-0.4,0.53-0.88,0.92-1.43,1.17C89.52,37.88,88.89,38,88.18,38
                c-0.63,0-1.22-0.12-1.76-0.35c-0.55-0.23-1.02-0.55-1.42-0.96c-0.4-0.41-0.72-0.9-0.94-1.46s-0.34-1.18-0.34-1.85
                c0-0.65,0.11-1.25,0.33-1.81c0.22-0.56,0.53-1.05,0.92-1.47c0.4-0.41,0.87-0.74,1.42-0.98c0.55-0.24,1.15-0.36,1.8-0.36
                c0.6,0,1.17,0.11,1.72,0.32c0.55,0.22,1.01,0.57,1.38,1.06L90.38,30.8z"
              />
              <path fill={stroke ?? '#FFFFFF'} d="M95.44,28.99h5.52v0.97h-4.48v2.76h4.18v0.97h-4.18v3.13h4.71v0.97h-5.75V28.99z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
